import React, { Component } from 'react';
import {Glyphicon, MenuItem, Nav, Navbar, NavDropdown, NavItem} from "react-bootstrap";
import auth from '../modules/Auth0_setup';
import { MainNavBody } from "../components/main-header-nav";

// TODO: AWS S3 cannot find key with logout href='/login'. Only works with React Router. But react router will

export default class SecondaryNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false
    }
  }

  render() {
    const { isSticky, profile } = this.props;
    return <Navbar className='sticky-nav-top'
                   fixedTop={isSticky}
                   collapseOnSelect
                   expanded={this.state.expanded}
                   onToggle={() => this.setState({ expanded: !this.state.expanded })}
    >
      <Navbar.Header>
        <Navbar.Brand className='visible-xs'>
          <img src='/images/SprintRayLogo-White.png'/>
        </Navbar.Brand>
        <Navbar.Toggle />
      </Navbar.Header>
      <Navbar.Collapse>
        <Nav bsStyle="pills" onSelect={this.changePage.bind(this)} >
          <NavItem eventKey={0} href="#" active={this.props.selectedPage === 0}>
            Print Jobs
          </NavItem>
          <NavItem eventKey={1} href="#" active={this.props.selectedPage === 1}>
            Your Printers
          </NavItem>
          <NavItem eventKey={2} href="#" active={this.props.selectedPage === 2}>
            Material Usage
          </NavItem>
        </Nav>

        <Nav pullRight onSelect={this.changePage.bind(this)}>

            <NavItem eventKey={4} href="#" active={this.props.selectedPage === 4}>
                Add Printer
            </NavItem>

          <NavItem eventKey={3} href="#" active={this.props.selectedPage === 3}>
            Account
          </NavItem>
          <NavItem eventKey={10} onClick={auth.logout} href="/login">
            Logout
          </NavItem>

        </Nav>
        <hr className='visible-xs hr-between'/>
        <MainNavBody className='visible-xs'/>
      </Navbar.Collapse>
    </Navbar>
  }

  changePage(eventKey, event) {
    this.props.changePage(eventKey);
  };

  componentDidMount() {
    window.addEventListener('scroll', () => {
      this.setState({ expanded: false });
    })
  }
}


// WEBPACK FOOTER //
// ./src/components/secondary-nav.js